// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { EarTag, EarTagSchema } from 'api/gen/EarTag';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { EditApcBase, EditApcBaseSchema } from 'api/gen/EditApcBase';

const requiredPart = t.interface({
  correctionType: t.literal('EAR_TAG_UPDATE'),
  updatedEarTag: EarTagSchema,
});

export const EditApcEarTagUpdateSchema = excess(t.intersection([EditApcBaseSchema.type, requiredPart]));

export interface EditApcEarTagUpdate extends t.TypeOf<typeof EditApcEarTagUpdateSchema> {}
